if (!customElements.get('art-product-tabs')) {
  customElements.define('art-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          this.activate(next); this.tabs[next].focus();
        });
      });
      this.setupLooxWidget();
      this.setupArtistProfile();
    }
    disconnectedCallback() {
      if (this.looxMedia && this.placeLooxWidget) {
        this.looxMedia.removeEventListener?.('change', this.placeLooxWidget);
      }
    }
    setupLooxWidget() {
      const widget = this.querySelector('[data-loox-widget]');
      const desktopMount = this.querySelector('[data-loox-desktop-mount]');
      const mobileMount = this.querySelector('[data-loox-mobile-mount]');
      if (!widget || !desktopMount || !mobileMount) return;
      const media = window.matchMedia('(max-width: 749px)');
      const placeWidget = () => (media.matches ? mobileMount : desktopMount).after(widget);
      placeWidget();
      media.addEventListener?.('change', placeWidget);
      this.looxMedia = media;
      this.placeLooxWidget = placeWidget;
    }
    activate(index) {
      this.tabs.forEach((tab, current) => {
        const active = current === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = !active;
      });
    }
    setupArtistProfile() {
      this.artistTabs = [...this.querySelectorAll('[data-artist-tab]')];
      this.artistPanels = [...this.querySelectorAll('[data-artist-panel]')];
      this.artistTabs.forEach((tab) => tab.addEventListener('click', () => {
        const target = tab.dataset.artistTab;
        this.artistTabs.forEach((item) => item.setAttribute('aria-pressed', String(item === tab)));
        this.artistPanels.forEach((panel) => { panel.hidden = panel.dataset.artistPanel !== target; });
      }));
      const readMore = this.querySelector('[data-artist-read-more]');
      const bio = this.querySelector('[data-artist-bio]');
      readMore?.addEventListener('click', () => {
        const expanded = !bio.classList.contains('is-expanded');
        bio.classList.toggle('is-expanded', expanded);
        readMore.setAttribute('aria-expanded', String(expanded));
        readMore.firstChild.textContent = expanded ? 'Read Less ' : 'Read More ';
      });
    }
  });
}

if (!customElements.get('art-artist-profile')) {
  customElements.define('art-artist-profile', class extends HTMLElement {
    connectedCallback() {
      this.artistTabs = [...this.querySelectorAll('[data-artist-tab]')];
      this.artistPanels = [...this.querySelectorAll('[data-artist-panel]')];
      this.artistTabs.forEach((tab) => tab.addEventListener('click', () => {
        const target = tab.dataset.artistTab;
        this.artistTabs.forEach((item) => item.setAttribute('aria-pressed', String(item === tab)));
        this.artistPanels.forEach((panel) => { panel.hidden = panel.dataset.artistPanel !== target; });
      }));
      const readMore = this.querySelector('[data-artist-read-more]');
      const bio = this.querySelector('[data-artist-bio]');
      readMore?.addEventListener('click', () => {
        const expanded = !bio.classList.contains('is-expanded');
        bio.classList.toggle('is-expanded', expanded);
        readMore.setAttribute('aria-expanded', String(expanded));
        readMore.firstChild.textContent = expanded ? 'Read Less ' : 'Read More ';
      });
    }
  });
}
